export default __webpack_public_path__ + "static/media/bs.4cdf4b3c.svg";